import configureStore from "./components/app/store/configureStore";

const store = configureStore();
export default store;



// WEBPACK FOOTER //
// ./src/store.js